import React, { Component } from 'react';

import Radio from './Radio';

class RadioGroup extends Component {
    render() {
        return (
            <div className="pp-radio-group">
                <p className="pp-radio-group-label">{ this.props.label }</p>
                <div className="pp-radio-inputs">

                    {this.props.radioOptions.map(radio => (
                        <Radio
                            label={radio.label}
                            htmlName={radio.htmlName}
                            htmlID={radio.htmlID}
                            checked={radio.checked}
                            defaultValue={radio.defaultValue}
                        />
                    ))}

                </div>
            </div>
        );
    }
}

export default RadioGroup;



// WEBPACK FOOTER //
// ./src/components/RadioGroup.js